import { render } from "./dsp-review.vue?vue&type=template&id=53f59fb0"
import script from "./dsp-review.js?vue&type=script&lang=js"
export * from "./dsp-review.js?vue&type=script&lang=js"

import "./dsp-review.vue?vue&type=style&index=0&id=53f59fb0&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__